/*
 * @Description: 存塘概览-育苗
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-01-18 10:00:11
 */
import http from "@/axios/index";
/**接口根路经标识 */

// --------------------------实时存塘量
export function initPageList(data) {
  const url = `/mdtPondStockOrg/searchMdtPondStockOrgList`
  return http.post(url, data)
}


// --------------------------月存塘成本
export function monthInitPageList(data){
  const url = `/midCostTotalOrg/getMonthlyStoragePondCost`
  return http.post(url, data)
}

// 获取所有机构--实时存塘量
export function getAllJiGou(rootId){
  const url = `/desktopReport/queryCuntangOrg/${rootId}`
  return http.get(url)
}

// 获取所有批次--实时存塘量
export function getAllPiCi(rootId){
  const url = `/desktopReport/queryCuntangBatch/${rootId}`
  return http.get(url)
}
// 获取所有品类--实时存塘量
export function getAllPinLei(rootId){
  const url = `/desktopReport/queryCuntangType/${rootId}`
  return http.get(url)
}
// 获取所有品种--实时存塘量
export function getAllPinZhong(rootId){
  const url = `/desktopReport/queryCuntangBreed/${rootId}`
  return http.get(url)
}

// 获取全部机构--月存塘成本
export function getAllJiGouMonth(rootId){
  const url = `/desktopReport/queryYuecunPondOrg/${rootId}`
  return http.get(url)
}

// 获取全部育苗批次--月存塘成本
export function getAllPiCiMonth(rootId){
  const url = `/desktopReport/queryBatch/${rootId}`
  return http.get(url)
}
// 获取全部品类--月存塘成本
export function getAllPinLeiMonth(rootId){
  const url = `/desktopReport/queryType/${rootId}`
  return http.get(url)
}
// 获取全部品种--月存塘成本
export function getAllPinZhongMonth(rootId){
  const url = `/desktopReport/queryBreed/${rootId}`
  return http.get(url)
}
